import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { CreditCardModule } from 'projects/credit-card/src/lib/credit-card.module';
import { ReactiveFormsModule } from '@angular/forms';
import { Layout3dModule } from 'projects/layout3d/src/lib/layout3d.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    CreditCardModule.forRoot({}),
    Layout3dModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
